module.exports = __webpack_public_path__ + "57d40305f951ee3d455b87749ce0406f.png";